import { render } from "./DataFieldComponent.vue?vue&type=template&id=23c1b22c&scoped=true"
import script from "./DataFieldComponent.vue?vue&type=script&lang=js"
export * from "./DataFieldComponent.vue?vue&type=script&lang=js"

import "./DataFieldComponent.vue?vue&type=style&index=0&id=23c1b22c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c1b22c"]])

export default __exports__